import { Box, Button, Title } from '@factorialco/deprecated-design-system'
import PoliciesEmptyImage from 'assets/images/spending_policies/policies-empty.jpg'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const Landing = () => {
  const { navigation } = useNavigation()
  return (
    <Box justifyContent="center" textAlign="center" alignItems="center" gap="s32">
      <img src={PoliciesEmptyImage} alt="" aria-hidden="true" />
      <Title
        variant="500"
        title={i18n.t('spending_policies.landing.title')}
        description={i18n.t('spending_policies.landing.description')}
        centered
      />
      <Button.Router to={navigation.expenses.spendingPolicies.list.new.fullPath()}>
        {i18n.t('spending_policies.landing.cta')}
      </Button.Router>
    </Box>
  )
}

export default Landing
